export default "__VITE_ASSET__CnsV4Ia2__"